import axios from 'axios';
import config from '../config/api';

/**
 * Service API pour les requêtes HTTP
 * Utilise automatiquement la bonne URL d'API selon l'environnement
 */

// Création d'une instance axios avec la configuration de base
const apiClient = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Intercepteur pour les requêtes
apiClient.interceptors.request.use(
  (config) => {
    // Log en développement uniquement
    if (process.env.NODE_ENV !== 'production') {
      // console.log(`🔄 Requête API: ${config.method.toUpperCase()} ${config.url}`);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour les réponses
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Gestion des erreurs
    // console.error('❌ Erreur API:', error.response ? {
    //   status: error.response.status,
    //   data: error.response.data
    // } : error.message);
    
    return Promise.reject(error);
  }
);

// Méthodes d'API
const api = {
  // Tracking analytique
  trackVisit: (trackingData) => apiClient.post('/api/analytics/visit', trackingData),
  // Actes consulaires
  getConsularActs: () => apiClient.get('/api/consular-acts'),
  searchConsularActs: (query) => apiClient.get(`/api/consular-acts/search?query=${encodeURIComponent(query)}`),
  searchConsularActsWithParams: (params) => apiClient.get('/api/consular-acts/search', { params }),
  getConsularActById: (id) => apiClient.get(`/api/consular-acts/${id}`, { timeout: 15000 }),
  
  // Catégories
  getCategories: () => apiClient.get('/api/categories'),
  
  // Utilisateurs
  createUser: (userData) => apiClient.post('/api/users', userData),
  
  // Paiements
  createPaymentIntent: (paymentData) => apiClient.post('/api/payments/create-payment-intent', paymentData),
  registerPayment: (paymentData) => apiClient.post('/api/payments', paymentData),
  
  // Membres de famille
  /**
   * Crée des membres de famille en lot
   * @param {{ parent_id: string, members: Array<{lastname: string, firstname: string, email?: string, phone?: string}> }} payload
   * @returns {Promise}
   */
  createFamilyMembers: (payload) => apiClient.post('/api/family-members/bulk', payload),
  
  // Chatbot
  sendChatMessage: (message) => apiClient.post('/api/chatbot', { message }),
  sendChatMessageWithContext: (message, context) => axios.post('https://cgci-paris.monsieur-yapo.com/chat', { message, context }),
  storeChatMessage: (messageData) => apiClient.post('/api/store-chat-message', messageData),
  
  // Email
  sendConfirmationEmail: (emailData) => apiClient.post('/api/send-confirmation-email', emailData),
  
  // Expéditions
  createShipment: (shipmentData) => apiClient.post('/api/shipments', shipmentData),
  updateShipment: (shipmentId, shipmentData) => apiClient.put(`/api/shipments/${shipmentId}`, shipmentData),
};

export default api;
